import React, { useEffect, useRef } from 'react'
import ContactezNous from '../components/ContactezNous'
import FooterPage from '../components/FooterPage'

const Contact = () => {
  const topRef = useRef<HTMLDivElement>(null)

  useEffect(() =>{
    if(topRef){
      window.scrollTo(0,0)
    }
  },[])
  
  return (
    <div ref={topRef}>
      <ContactezNous/>
      <FooterPage/>
    </div>
  )
}

export default Contact